import { render, staticRenderFns } from "./app_index.vue?vue&type=template&id=3b0c94c6"
import script from "./app_index.vue?vue&type=script&lang=js"
export * from "./app_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports